import { API_BASE_URL } from "../config/api";
import { resolveApiMessage } from "../utils/resolveApiMessage";

export async function fetchDepositos({ centro }) {
  const url = new URL("/deposito/pi", API_BASE_URL);

  const response = await fetch(url.toString(), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ centro }),
  });

  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch {
    throw new Error("Não foi possível conectar ao servidor. Verifique se o backend está ativo.");
  }

  if (!response.ok || data.status === "nok") {
    throw new Error(resolveApiMessage(data, "Erro ao buscar depósitos no SAP PI"));
  }

  return data.data;
}
